<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新增用户</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="500px"
                style="width: 100%">
                <el-table-column prop="nickName" label="ID" align="center" width="100"></el-table-column>
                <el-table-column prop="phone" label="手机" align="center" width=""></el-table-column>
                <el-table-column prop="gender" label="性别" align="center" width="">
                    <template slot-scope="scope">
                        {{ scope.row.gender == 1 ? '男' : '女' }}
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="注册时间" align="center" width=""></el-table-column>
                <el-table-column prop="onlineState" label="状态" align="center" width="">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.onlineState == 2">最近活跃</el-tag>
                        <el-tag type="info" v-if="scope.row.onlineState == 3">离线</el-tag>
                        <el-tag type="info" v-if="scope.row.onlineState == 0">离线</el-tag>
                        <el-tag type="success" v-if="scope.row.onlineState == 1">在线</el-tag>
                    </template>
                </el-table-column>
               
                <el-table-column fixed="right" label="操作" width="200px" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="isManageDialogShow(scope.row)">封禁</el-button>
                        
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelTip(scope.row)">注销</el-button>
                        
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isRenzhengDialog" title="认证" width="640px">
            <div class="flex"></div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isCancelTip" title="注销用户" width="640px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        状态
                    </div>
                    <el-radio-group v-model="cancelData.state">
                        <el-radio :label="1">正常</el-radio>
                        <el-radio :label="-2">注销</el-radio>
                    </el-radio-group>
                </div>

                <div class="item" v-if="cancelData.state == -1">
                    <div class="label">
                        封禁时间(天)
                    </div>
                    <div class="value" style="width:330px">
                        
                        <el-select v-model="cancelData.fengJinDay" placeholder="请选择封禁时间(天)" style="width:330px">
                            <el-option
                            v-for="(item,index) in fengJinDayList"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="FJData.fengJinDay" placeholder="请输入封禁时间(天)" type="number"></el-input> -->
                    </div>
                </div>
                
                <!-- <div class="item" v-if="cancelData.state == -1">
                    <div class="label">
                        封禁原因
                    </div>
                    <div class="value" style="width:400px">
                        <el-select v-model="cancelData.fengJinRemark" placeholder="请选择" style="width:330px">
                            <el-option
                            v-for="(item,index) in fengJinRemarkList"
                            :key="index"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
               
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="cancelUser()">确认</el-button>
                </div>

            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isManageDialog" title="处理用户" width="640px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        状态
                    </div>
                    <el-radio-group v-model="FJData.state">
                        <el-radio :label="1">正常</el-radio>
                        <el-radio :label="-1">封禁</el-radio>
                    </el-radio-group>
                </div>

                <div class="item" v-if="FJData.state == -1">
                    <div class="label">
                        封禁时间(天)
                    </div>
                    <div class="value" style="width:330px">
                        
                        <el-select v-model="FJData.fengJinDay" placeholder="请选择封禁时间(天)" style="width:330px">
                            <el-option
                            v-for="(item,index) in fengJinDayList"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="FJData.fengJinDay" placeholder="请输入封禁时间(天)" type="number"></el-input> -->
                    </div>
                </div>
                
                <div class="item" v-if="FJData.state == -1">
                    <div class="label">
                        封禁原因
                    </div>
                    <div class="value" style="width:400px">
                        <el-select v-model="FJData.fengJinRemark" placeholder="请选择" style="width:330px">
                            <el-option
                            v-for="(item,index) in fengJinRemarkList"
                            :key="index"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
               
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="manageUser()">确认</el-button>
                </div>

            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {Education, Income, MaritalType} from '../../../assets/selectList/index'
const options = [{ label: '是', value: true },{ label: '否', value: false }]
const memberTypeList = [
    { label: '普通用户', value: 0 },
    { label: '普通会员', value: 1 },
    { label: '尊享会员', value: 2 },
    { label: '体验会员', value: 3 }
]
export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            Education:Education,
            Income:Income,
            MaritalType:MaritalType,
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            
            
            totalCount:0,
            tableData:[],
            conditionData:{
                UserId: "",
                Phone: "",
                NickName: "",
                Gender: null,
                Province: null,
                City: null,
                Area: null,
                State: 0,
                Vip: null,
                RealName: null,
                IsEducation: null,
                IsRealEstate: null,
                IsVehicle: null,
                IsIncome: null,
                IsCareer: null,
                keyword:'',
                page:1,
                pageSize:10,
            },
            
            queryList:[
                {type: "input",label: "用户ID:",name: "UserId"},
                {type: "input",label: "手机号:",name: "Phone"},
                {type: "input",label: "昵称:",name: "NickName"},
                {type: "select",label: "性别:",name: "Gender",options:[{ label: '男', value: 1 },{ label: '女', value: 2 }]},
                {type: "select",label: "用户状态:",name: "State",options:[{ label: '正常', value: 1 },{ label: '注销', value: -2 },{ label: '封禁', value: -1 },{ label: '信息未完善', value: 0 }]},
                {type: "input",label: "省:",name: "Province"},
                {type: "input",label: "市:",name: "City"},
                {type: "input",label: "区:",name: "Area"},
                // {type: "select",label: "用户状态:",name: "State",options:options},
                {type: "select",label: "会员类型:",name: "memberType",options:memberTypeList},
                {type: "select",label: "是否实名认证:",name: "RealName",options:options},
                {type: "select",label: "是否认证学历:",name: "IsEducation",options:options},
                {type: "select",label: "是否认证房产:",name: "IsRealEstate",options:options},
                {type: "select",label: "是否认证车辆:",name: "IsVehicle",options:options},
                {type: "select",label: "是否认证收入:",name: "IsIncome",options:options},
                {type: "select",label: "是否认证职业:",name: "IsCareer",options:options},
            ],
            
            
            
          
            
          
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            imageCode:'',
            imageCodeUrl:'',
            fileName:'',
            isCancelTip: false,
            cancelData: {
                id: null,
                userId: null,
                phone: null,
                state: null,
                fengJinDay: null,
                fengJinRemark: null,
            },
            FJData:{
                id: null,
                userId: null,
                phone: null,
                state: null,
                fengJinDay: null,
                fengJinRemark: null,
            },
            isManageDialog: false,
            fengJinRemarkList:[
                '发送第三方联系方式/扰乱平台秩序行为',
                '私信涉及违反平台规定/扰乱平台秩序行为',
                '虚假资料/扰乱平台秩序行为',
                '疑似诈骗行为/扰乱平台秩序行为',
                '内容违规/扰乱平台秩序行为'
            ],
            fengJinDayList:[
                { label: '封禁1天', value: 1 },                
                { label: '封禁3天', value: 3 },                
                { label: '封禁7天', value: 7 },                
                { label: '封禁15天', value: 15 },                
                { label: '封禁30天', value: 30 },                
                { label: '永久封禁', value: 36500 },                
            ],
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();

    },
    methods:{
        renzheng(type,row){
            console.log(type);
            console.log(row);
        },
        async cancelUser(){
            let res = await api.UpdateUserState({
                "userId": this.cancelData.userId,
                "state": this.cancelData.state,
                "fengJin": {
                    "id": 0,
                    "userId": this.cancelData.userId,
                    "phone": this.cancelData.phone,
                    "fengJinDay": this.cancelData.fengJinDay?this.cancelData.fengJinDay:0,
                    "fengJinRemark": '您的账号（' + this.cancelData.id + '）由于“' + (this.cancelData.fengJinRemark?this.cancelData.fengJinRemark:'') + '”违规已被封禁' + this.FJData.fengJinDay + '天',
                    "isChuli": false
                }
            });
            if(res.data.code == 200){
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isManageDialog = false
                this.loadingData();
            }
            
        },
        async manageUser(){
            let res = await api.UpdateUserState({
                "userId": this.FJData.userId,
                "state": this.FJData.state,
                "fengJin": {
                    "id": 0,
                    "userId": this.FJData.userId,
                    "phone": this.FJData.phone,
                    "fengJinDay": this.FJData.fengJinDay?this.FJData.fengJinDay:0,
                    "fengJinRemark": '您的账号（' + this.FJData.id + '）由于“' + (this.FJData.fengJinRemark?this.FJData.fengJinRemark:'') + '”违规已被封禁' + this.FJData.fengJinDay + '天',
                    "isChuli": false
                }
            });
            if(res.data.code == 200){
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isManageDialog = false
                this.loadingData();
            }
            
        },
        cancelTip(row){
            this.cancelData.userId = row.userId;
            this.cancelData.id = row.id;
            this.cancelData.state = row.state;
            this.cancelData.phone = row.phone;
            this.isCancelTip = true;
        },
        isManageDialogShow(row){
            this.FJData.userId = row.userId;
            this.FJData.id = row.id;
            this.FJData.state = row.state;
            this.FJData.phone = row.phone;
            this.isManageDialog = true;
        },
        deleteTip(row){
            this.$confirm('将删除此用户?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(row){
            let res = await api.DeleteUser({
                userId:row.userId
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '已取消退出'
                });
                this.loadingData();

            }
        },
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }else if(this.isDetailDialog){
                this.isDetailDialog = false
            }
        },
        
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        detailShow(item){
            this.$router.push({ path:'userDetail',query:{id:item.userId} });
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.UserPager(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            for(let i in this.tableData){
                if(this.tableData[i].myTags){
                    let myTags = JSON.parse(this.tableData[i].myTags)
                    if(myTags.XingGe){
                        this.tableData[i].xingGe = myTags.XingGe
                    }
                    if(myTags.AiHao){
                        this.tableData[i].aiHao = myTags.AiHao
                    }
                    if(myTags.LianAi){
                        this.tableData[i].lianAi = myTags.LianAi

                    }
                }
            }
        },
    
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                UserId: "",
                Phone: "",
                NickName: "",
                Gender: null,
                Province: null,
                City: null,
                Area: null,
                State: 0,
                Vip: null,
                RealName: null,
                IsEducation: null,
                IsRealEstate: null,
                IsVehicle: null,
                IsIncome: null,
                IsCareer: null,
                keyword:'',
                page:1,
                pageSize:10,
            };
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        
            
        showAddDialog(){
            this.isAddDialog = true;
        },
        
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 100%;
    }
    .rz{
        color: #409eff;
        cursor: pointer;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .flexw{
        display: flex;
        flex-wrap: wrap;
    }
    .rz-img{
        margin-right: 6px;
        margin-top: 6px;
        width: 32px;
        height: 32px;
    }
    .rz-img3{
        opacity: .3;
    }
    .rz-img-c{
        cursor: pointer;
    }
    .flexccs{
        display: flex;
        align-items: center;
    }
    .flexcc{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tablei>span{
        color: #999999;
    }
    .qrcodedivd{
        display: flex;
        justify-content: center;
    }
    #qrCode {
        display: inline-block;
        margin: 0 auto; /*水平居中*/
        position: relative;
        top: 15%;
        
        img {
            width: 200px;
            height: 200px;
            background-color: #fff; //设置白色背景色
            padding: 6px; // 利用padding的特性，挤出白边
        }
    }
    /deep/.el-image-viewer__canvas{
        img{
            height: 50%;
        }
    }


</style>
